import React from 'react';

const ReviewRequestEmailSvg = ({ color = '#000', size = 24, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M7.5 6L14.25 10.5L21 6M3 12.75H10.5M4.5 15.75H12M6.75 18.75H21.75V5.25H6.75V9.75H1.5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
    </svg>
);

export default ReviewRequestEmailSvg;
